import { DisaggregatedMetric, MetricPanelProps } from "../../services/types";
import { getMetricGroupChartId, getMetricGroupOrderIds, getSvgMap } from "../../utils/dashboardUtils";
import MetricCard from "../MetricCard";
import ComparisonChart from "../charts/ComparisonChart";
import DisaggregateMetricCard from "../DisaggregateMetricCard";
import BannerRibbon from "../BannerRibbon";
import SingleBar from "../charts/SingleBar";
import { useCountyAgeData } from "../../context/CountyAgeDataContext";

const ChildFamilyMetrics = ({ indicators, categorizedData, tab, geoDetails, geoTag, selectionActive }: MetricPanelProps) => {  
    const countyAgeData = useCountyAgeData();
    const orders = getMetricGroupOrderIds(tab);

    const sortedMetrics = orders.map((order: number[]) => 
        categorizedData["Child & family"]
            .filter(metric => order.includes(metric.id))
            .sort((a, b) => order.indexOf(a.id) - order.indexOf(b.id))
    );
    console.log('Child and family metrics:', sortedMetrics);

    const fam: DisaggregatedMetric[] = sortedMetrics[0];

    const fam2: DisaggregatedMetric[] = sortedMetrics[1];

    const singleFathers = fam2.find(metric => metric.id === 1192) || null;
    const singleMothers = fam2.find(metric => metric.id === 1193) || null;

    let metricsForTab = indicators; // Get metrics for the current tab

    if (!metricsForTab || metricsForTab.length === 0) {
        return <div className="flex items-center justify-center text-color-cai-dashboard">No metrics available for {tab}.</div>;
    }


    return (
        <>  
            <div className="mb-2">
                <BannerRibbon text="Child and Family Well-Being" color="#225591"/>
            </div>
            <p className="text-port-text mx-4 text-[10px] mb-4">Data updates published July 15, 2025. Data testing in progress.</p>          
            <div className="grid grid-cols-2 gap-4 place-items-start ml-4">
                {fam.map(metric => (
                    <MetricCard
                        key={metric.id}
                        metric={metric}
                        width="w-full"
                        svg={getSvgMap(metric.id)}
                        disaggData={indicators}
                        geoDetails={geoDetails}
                        geoTag={geoTag}
                        selectionActive={selectionActive}
                    />
                ))}

                <div className="col-span-2 w-full pr-4">
                    {categorizedData["Child & family"].filter(metric => 
                        [getMetricGroupChartId(tab, "childrenage")].includes(metric.id) // Percent of Children by Age group
                    ).map(metric => (
                        <DisaggregateMetricCard
                            key={metric.id}
                            id={metric.id}
                            metric={metric}
                            title={"Percentage of Children by Age Group"}
                            svg={getSvgMap(metric.id)}
                            disaggData={indicators}
                            geoDetails={geoDetails}
                            geoTag={geoTag}
                            selectionActive={selectionActive}
                            showValue={false}
                        />
                    ))}
                    <ComparisonChart indicators={indicators} metricId={1194} countyData={countyAgeData} geoTag={geoTag} geoDetails={geoDetails} title="Percent of Children by Age Group" height="h-72" />
                </div>

                <div className="col-span-2 w-full pr-4 mt-2 mb-4">
                    <div className="bg-anti-flash pb-2">
                        {categorizedData["Child & family"].filter(metric => 
                            [getMetricGroupChartId(tab, "singleparent")].includes(metric.id) // Single Parent Families
                        ).map(metric => (
                            <DisaggregateMetricCard
                                key={metric.id}
                                id={metric.id}
                                metric={metric}
                                title={metric.name}
                                svg={getSvgMap(metric.id)}
                                disaggData={indicators}
                                geoDetails={geoDetails}
                                geoTag={geoTag}
                                selectionActive={selectionActive}
                                showValue={true}
                            />
                        ))}
                        
                        {singleMothers && 
                        <>
                        <SingleBar
                            key={singleMothers.id}
                            metric={singleMothers}
                            name="Single Mothers"
                            width="w-full"
                            svg={getSvgMap(singleMothers.id)}
                            disaggData={indicators}
                            geoDetails={geoDetails}
                            geoTag={geoTag}
                            selectionActive={selectionActive}
                        />
                        
                        </>
                        }
                        {singleFathers && 
                        <SingleBar
                            key={singleFathers.id}
                            metric={singleFathers}
                            name='Single Fathers'
                            width="w-full"
                            svg={getSvgMap(singleFathers.id)}
                            disaggData={indicators}
                            geoDetails={geoDetails}
                            geoTag={geoTag}
                            selectionActive={selectionActive}
                        />
                        }
                    </div>
                </div>
            </div>

            
        </>
    );
}

export default ChildFamilyMetrics;